import { isNodeShadowHost } from '@datadog/browser-rum-core';
export function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
export function getEventTarget(event) {
    if (event.composed === true && isNodeShadowHost(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
var recordIds = new WeakMap();
var nextId = 1;
export function getRecordIdForEvent(event) {
    if (!recordIds.has(event)) {
        recordIds.set(event, nextId++);
    }
    return recordIds.get(event);
}
//# sourceMappingURL=utils.js.map